import type {} from 'svelte'; // Allow Svelte compontents to be handled correctly with TypeScript

import BuyLoungePassModal from '../../components/BuyLoungePass.svelte';
import ModalBookingSuccess from '../../components/ModalBookingSuccess.svelte';
import ModalBookingTryAgain from '../../components/ModalBookingTryAgain.svelte';

import type {HydrateJSON, Response} from '../../components/BuyLoungePass/types';

const hydrate: HydrateJSON | undefined = window.hydrateJSON;

function modal(el: HTMLElement, state: 'hide' | 'show')  {
    // @ts-ignore There are no bindings for Bootstrap modal usage
    $(el).modal(state);

    if (state === 'show') {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '15px';
    } else {
        document.body.style.overflow = 'auto';
        document.body.style.overflowX = 'hidden';
        document.body.style.paddingRight = '0';
    }
}

function onModalHidden(el: HTMLElement, cb: () => void)  {
    // @ts-ignore There are no bindings for Bootstrap modal usage
    $(el).on('hidden.bs.modal', cb);
}

if (!hydrate) {
  console.log('hydrate missing');
}

let loungePassElement: HTMLDivElement;
let successElement: HTMLDivElement;
let tryAgainElement: HTMLDivElement;

let successModal: ModalBookingSuccess | undefined;
function openSuccessModal(props: Record<string, any> | undefined) {
  successModal = new ModalBookingSuccess({
    target: document.body,
    props: {
      hydrate,
      ...props,

      onReady(el: HTMLDivElement) {
        successElement = el;
        onModalHidden(successElement, () => {
        })
        modal(successElement, 'show');
      },
      onClose() {
        modal(successElement, 'hide');
      },
    }
  });
}

let tryAgainModal: BuyLoungePassModal | undefined;
function openTryAgainModal(props: Record<string, any> | undefined) {
  tryAgainModal = new ModalBookingTryAgain({
    target: document.body,
    props: {
      hydrate,
      ...props,

      onReady(el: HTMLDivElement) {
        tryAgainElement = el;
        onModalHidden(tryAgainElement, () => {
          tryAgainModal?.$destroy();
        })
        modal(tryAgainElement, 'show');
      },
      onClose() {
        modal(tryAgainElement, 'hide');
      },
    }
  });

}



let loungePassModal: BuyLoungePassModal | undefined;
export function openBuyLoungePassModal() {
  if (loungePassModal != null) return;

  loungePassModal = new BuyLoungePassModal({
    target: document.body,
    props: {
      hydrate,

      onReady(el: HTMLDivElement) {
        loungePassElement = el;
        onModalHidden(loungePassElement, () => {
          loungePassModal?.$destroy();
          loungePassModal = undefined;
        })
        modal(loungePassElement, 'show');
      },
      onClose() {
        modal(loungePassElement, 'hide');
      },
      onSuccess(responseData: Response) {
        modal(loungePassElement, 'hide');

        const hasMultiplePasses = responseData.duration_qty > 1 || responseData.capacity > 1;
        openSuccessModal({
          title: `Lounge Passes Reserved!`,
          message: `Your booking of $${responseData.amount_paid_usd}USD has been purchased!`,
          responseData,
        })
      },
      onError(responseData?: Response) {
        openTryAgainModal({
          technicalError: responseData == null,
          responseData: responseData == null ? {} : responseData
        });
      },
    }
  });
}